import type { Move } from "@dailywars/core/engine";

function moveUnitId(move: Move): string | null {
  if (move.type === "endTurn" || move.type === "build") return null;
  return move.unitId;
}

function isSingleGestureCompound(first: Move, second: Move): boolean {
  const secondUnitId = moveUnitId(second);
  const firstUnitId = moveUnitId(first);
  if (!secondUnitId || firstUnitId !== secondUnitId) return false;

  if (first.type === "move" && (second.type === "capture" || second.type === "prepareUnload")) {
    return true;
  }
  if (first.type === "prepareUnload" && (second.type === "unload" || second.type === "wait")) {
    return true;
  }
  return false;
}

export function countMovesInLastUserAction(moves: Move[]): number {
  if (moves.length === 0) return 0;

  let count = 1;
  let index = moves.length - 2;
  while (index >= 0 && isSingleGestureCompound(moves[index]!, moves[index + 1]!)) {
    count++;
    index--;
  }
  return count;
}
